/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, message, Table } from "antd";
import { ReportsService } from "../../../../services/api/reports";
import Heading from "../../../../components/Heading";
import "../styles.scss";

const DeliveryDetails = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [detailsData, setDetailsData] = useState([]);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 50,
        total: 0,
        showSizeChanger: true,
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
    });

    const { date, cpId, key, type, hubName, cpName, hubId } = location.state || {};
    console.log("location.state", location.state);

    // Single useEffect for initial validation and data fetch
    useEffect(() => {
        if (!date || !cpId || !key || !hubId) {
            message.error("Invalid parameters");
            navigate("/delivery-mis-report");
            return;
        }
        fetchDetails(1, pagination.pageSize);
    }, []); // Only run once on mount

    const fetchDetails = async (page = 1, pageSize = 10) => {
        if (!date || !cpId || !key || !hubId) return;
        
        setLoading(true);
        try {
            const response = await ReportsService.getDRSReport({
                startDate: date,
                endDate: date,
                cpId: cpId,
                key: key,
                page: page,
                limit: pageSize,
                hubId: hubId
            });

            if (response?.data) {
                setDetailsData(response.data);
                setPagination(prev => ({
                    ...prev,
                    total: response.total || 0
                }));
            } else {
                setDetailsData([]);
                setPagination(prev => ({
                    ...prev,
                    total: 0
                }));
                message.error("No data available");
            }
        } catch (error) {
            console.error("Error fetching details:", error);
            message.error(error?.message || "Failed to fetch details");
            setDetailsData([]);
            setPagination(prev => ({
                ...prev,
                total: 0
            }));
        } finally {
            setLoading(false);
        }
    };

    const handleTableChange = (newPagination) => {
        fetchDetails(newPagination.current, newPagination.pageSize);
    };

    const columns = [
        {
            title: "AWB Number",
            dataIndex: "awbNumber",
            key: "awbNumber",
            width: 150,
            render: (text) => (
                <span
                    style={{ color: "#1890ff", cursor: "pointer", textDecoration: "underline" }}
                    onClick={() => {
                        const url = `/shipment-tracker?awb=${text}`;
                        window.open(url, "_blank");
                    }}
                >
                    {text}
                </span>
            )
        },
        {
            title: "Status",
            dataIndex: "currentStatus",
            key: "currentStatus",
            width: 120,
        },
    ];

    return (
        <div className="report-container">
            <div style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>
                <Heading 
                    title={`${type} Details`} 
                />
            </div>
            <Card className="report-card">
            <div style={{ fontSize: "16px", fontWeight: "500", display: "flex", gap: "8px", alignItems: "center" }}>
                    <div style={{ padding: "8px 16px", background: "#f5f5f5", borderRadius: "4px" }}>
                        <span style={{ color: "#666" }}>Hub:</span> {hubName}
                    </div>
                    <div style={{ padding: "8px 16px", background: "#f5f5f5", borderRadius: "4px" }}>
                        <span style={{ color: "#666" }}>CP:</span> {cpName}
                    </div>
                </div>
                <Table
                    columns={columns}
                    dataSource={detailsData}
                    loading={loading}
                    pagination={pagination}
                    onChange={handleTableChange}
                    scroll={{ y: "calc(100vh - 300px)", x: "max-content" }}
                    sticky
                />
            </Card>
        </div>
    );
};

export default DeliveryDetails; 
